var _path;

import * as React from "react";

function SvgFileChart(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24h-1c-.275 0-.5.225-.5.5v6c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-6c0-.275-.225-.5-.5-.5zm4-6h-1c-.275 0-.5.225-.5.5v12c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-12c0-.275-.225-.5-.5-.5zm2.5 4.5v8c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-8c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5zm8.119-12.376L25.876 4.88A3 3 0 0023.758 4H11a3.01 3.01 0 00-3 3.006V33a3 3 0 003 3h18a3 3 0 003-3V12.249c0-.793-.319-1.562-.881-2.124zm-7.117-4.087a.983.983 0 01.462.262l5.243 5.243a.984.984 0 01.262.462h-5.967V6.037zM30 33c0 .55-.45 1-1 1H10.999c-.55 0-1-.45-1-1V7.006A1.01 1.01 0 0111 6h11.003v6.504c0 .832.669 1.496 1.5 1.496H30v19z"
  })));
}

export default SvgFileChart;